// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__30A69","label":"Category_label__2IJUo","content":"Category_content__3fYBH","header":"Category_header__2zUqd","location":"Category_location__2s_N1"};